import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {BreadCrumbs} from "../../../components/open/pages";
import {AuthRedirectParents, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {StudentsConsentVerifyModal} from "./verify-modal";

export const StudentsViewConsentScreen = () => {
    const {consentNd} = useParams();
    const [data, setData] = useState({
        loaded: false,
        title: '',
        about: '',
        createdAt: '2000-01-01 00:00:00',
        expiresAt: '2000-01-01 00:00:00',
        signed: false,
    });
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/parents/consents/get',
            {
                nd: consentNd,
            },
            true,
            (d: {
                result: string,
                reason: string,
                title: string,
                about: string,
                createdAt: string,
                expiresAt: string,
                signed: boolean,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                setData({
                    loaded: true,
                    title: d.title,
                    about: d.about,
                    createdAt: d.createdAt,
                    expiresAt: d.expiresAt,
                    signed: d.signed,
                });
            },
            () => {
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "مشاهده رضایت‌نامه | نهال";
        fetchData();
    }, []);
    const [signModal, setSignModal] = useState(false);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'پنل دانش‌آموزان', url: '/students/'},
                {title: 'رضایت‌نامه ها', url: '/students/consents'},
                {title: data.loaded ? data.title : '...', url: `/students/consents/view/${consentNd}`},
            ]}/>
            {
                data.loaded ?
                    <div className="container" data-aos={"fade-up"} data-aos-duration={1000}>
                        <div className="row justify-content-center">
                            <div className="col-lg-7">
                                <div className="sci-class-view">
                                    <b>{data.title}</b>
                                    <i>رضایت‌نامه</i>
                                    <p><pre style={{whiteSpace:'normal'}}>{data.about}</pre></p>
                                    <div className="sci-class-view-feature">
                                        <span>وضعیت: </span>
                                        <b>{data.signed ? 'امضا شده' : 'هنوز امضا نشده است'}</b>
                                    </div>
                                    {
                                        !data.signed ?
                                            <div className="d-flex justify-content-end align-items-center"
                                                 style={{padding: '20px 20px 0 20px'}}>
                                                <button className="btn-pay" onClick={() => setSignModal(true)}>
                                                    <b>امضا رضایت‌نامه</b>
                                                </button>
                                            </div> : null

                                    }
                                </div>
                            </div>
                        </div>
                    </div> : null
            }
            <StudentsConsentVerifyModal
                active={signModal}
                closeHandler={() => setSignModal(false)}
                consentNd={consentNd as string}
                title={data.title}
                onDone={() => {
                    ShowProgressLoading();
                    fetchData();
                }}
            />
        </>
    );
};